<script>
export default {
  name: 'PublishTooltip',
  props: {
    row: {
      type: Object,
      default: null,
    },
  },
}
</script>

<template>
  <span
    :class="row.failureReason && $style.cell"
    :title="row.failureReason"
  >
    {{ row.failureReason || '—' }}
  </span>
</template>

<style lang="scss" module>
  .cell {
    display: block;
    width: 100%;
    overflow: hidden;
    color: #fc1e1e;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
